import { find, get } from "lodash";
import React from "react";
import * as MobileDetect from "react-device-detect";
import Modal from "~/components/common/molecules/Modal";
import HomePageDesktop from "~/components/desktop/pages/Home";
import HomePageMobile from "~/components/mobile/pages/Home";
import { partnerInfo } from "~/configs/partnerDetails";

const { Component } = require("react");

const info = get(partnerInfo, "info");
const iosUrl = find(info, { key: "ios" });
const androidUrl = find(info, { key: "android" });

class ExamResultQR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleModalConfirm: true,
      typeFeature: ""
    };
  }

  handleOpenToggleModalConfirm = type => {
    this.setState({ toggleModalConfirm: true, typeFeature: type });
  };

  handleCloseToggleModalConfirm = () => {
    this.setState({ toggleModalConfirm: false, typeFeature: "" });
  };

  render() {
    const { device } = this.props;
    const pathName = this.props.location.pathname;
    return (
      <React.Fragment>
        {" "}
        {device === "mobile" ? (
          <HomePageMobile
            {...this.props}
            menuBarBottomRef={this.menuBarBottomRef}
          />
        ) : (
          <HomePageDesktop
            {...this.props}
            menuBarBottomRef={this.menuBarBottomRef}
          />
        )}{" "}
        <Modal
          modal={this.state.toggleModalConfirm}
          // title="Xem cách tìm mã số thanh toán"
          // eslint-disable-next-line react/jsx-handler-names
          toggle={this.handleCloseToggleModalConfirm}
          children="Vui lòng sử dụng app BV Chợ Rẫy để được nhận ngay kết quả xét nghiệm và đơn thuốc."
          centered
          className="centered"
          cancelText=""
          openText="Mở app"
          okText="Tải app"
          onOpen={() => {
            this.setState({ toggleModalConfirm: false });
            window.location.href = "vn.com.medpro.choray:/" + pathName;
          }}
          onOk={() => {
            let url = "/";
            if (MobileDetect.isIOS) {
              url = iosUrl.value;
            } else if (MobileDetect.isAndroid) {
              url = androidUrl.value;
            } else {
              url = "/";
            }
            window.location.href = url;
          }}
          footer
          footerConfirm
        />
      </React.Fragment>
    );
  }
}

export default ExamResultQR;
